var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.opened
    },
    on: {
      close: _vm.closeModal
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v(" " + _vm._s(_vm.cr_guided.title) + " ")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c(
              "p",
              {
                staticClass: "body-1"
              },
              [_vm._v(" " + _vm._s(_vm.cr_guided.offer_msg) + " ")]
            )
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: "",
                  loading: _vm.loadingDecline
                },
                on: {
                  click: _vm.decline
                }
              },
              [_vm._v(" Decline Offer ")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primayr: "",
                  loading: _vm.loadingAccept
                },
                on: {
                  click: _vm.accept
                }
              },
              [_vm._v(" Accept Offer ")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }